/*
*
* File JS componente Share
*
*/

// IMPORT MODULES
//--------------------------------------------------------------------//

// Nulla al momento


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './share.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const share = () =>
{
    const buttonsOpenModal = document.querySelectorAll('[data-share]');
    if( !buttonsOpenModal.length ) return;

    const modal = document.querySelector('.share');
    if( !modal ) return;

    const buttonClose = modal.querySelector('.share__close');
    const buttonsShare = modal.querySelectorAll('.share__list-link');


    // APRIAMO LA MODALE PER LO SHARE
    //----------------------------------------------------------------//
    buttonsOpenModal.forEach(buttonOpenModal =>
    {
        buttonOpenModal.addEventListener('click', (evt) =>
        {
            evt.preventDefault();
            modal.classList.add('is-open');
        });
    });


    // CHIUDIAMO LA MODALE PER LO SHARE
    //----------------------------------------------------------------//
    buttonClose.addEventListener('click', (evt) =>
    {
        evt.preventDefault();
        modal.classList.remove('is-open');
    });


    // CHIUDIAMO LA MODALE PER LO SHARE CON IL TASTO ESC
    //----------------------------------------------------------------//
    document.addEventListener('keyup', (evt) =>
    {
        if(evt.code === 'Escape')
        {
            if( modal.classList.contains('is-open') )
            {
                modal.classList.remove('is-open');
            }
        }
    });


    // PULSANTI SHARE
    //----------------------------------------------------------------//
    buttonsShare.forEach(buttonShare =>
        {
            buttonShare.addEventListener('click', (evt) =>
            {
                let target = buttonShare.getAttribute('target');
                let permalink = buttonShare.href;

                if( !target ) return;
                if( target.toLocaleLowerCase() !== '_blank' ) return;

                evt.preventDefault();
                
                window.open(permalink, target, 'left=100,top=100,width=768,height=500');
            });
        });
}

export default share;

//--------------------------------------------------------------------//